export default {"src":"/_next/static/media/minus_bold.ce8e57e5.svg","height":24,"width":24};